import React, { Suspense, lazy } from 'react'
import { Route, Redirect, Switch } from 'react-router-dom'

import RootContainer from './containers/RootContainer'
import Constants from './services/constants/Constants'
import LoaderContainer from './containers/LoaderContainer'
const NotFound = lazy(() => import('./components/Errors/404/NotFound'));

const ApplicationsRoutes = () => {
  return (
    <Suspense fallback={<LoaderContainer force={true} />}>
      <Switch>
        <Route path={Constants.RoutesConstants.root} component={RootContainer} />
        <Route path={Constants.RoutesConstants.error.error404} component={NotFound} />
        <Redirect from='*' to={Constants.RoutesConstants.root} />
      </Switch>
    </Suspense>

  )
}
export default ApplicationsRoutes